"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IERC1822ProxiableUpgradeable__factory", {
  enumerable: true,
  get: function get() {
    return _IERC1822ProxiableUpgradeable__factory.IERC1822ProxiableUpgradeable__factory;
  }
});

var _IERC1822ProxiableUpgradeable__factory = require("./IERC1822ProxiableUpgradeable__factory");